import { useMutation } from 'react-query'
import { useNavigate, useParams } from 'react-router-dom'
import { joinAbsRoute } from 'src/common/utils'
import { AppEvents, ROUTES } from 'src/constants'
import { accountsService } from 'src/services/accounts.service'

const useRemoveAccount = () => {
  const { accountId } = useParams()
  const navigate = useNavigate()

  return useMutation(
    async () => {
      if (!accountId) return null
      return await accountsService.removeAccount(accountId)
    },
    {
      onSuccess: (data) => {
        if (!data) return

        const detail = {
          message: 'Account has been closed',
        }
        const event = new CustomEvent(AppEvents.HTTP_SUCCESS, { detail })
        document.dispatchEvent(event)

        navigate(joinAbsRoute(ROUTES.ACCOUNTS))
      },
    },
  )
}

export { useRemoveAccount }
